
<template>
  <naj-box :title="locales.sectionTitle">
    <v-row>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.leaseTypeOfContract"
          :label="locales.typeOfContract"
          :items="typeOfContract"
          item-value="id"
          item-text="name"
          :validates="`required|isValid: ${locales.typeOfContractValidation}, ${formModel.leaseTypeOfContract !== 3}`"
          :disabled="isChecking || viewMode"
          :generated-id.sync="formModel.validators.leaseTypeOfContract"
          @change="resetForm"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.leaseTypeOfContract == 1 || (formModel.leaseTypeOfContract == 3 && false)"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.purposeOfTheLease"
          :label="locales.purposeOfTheLease"
          :items="purposeOfTheLease"
          item-value="id"
          item-text="name"
          validates="required"
          :disabled="isChecking || viewMode"
          @change="purposeOfTheLeaseReset"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.purposeOfTheLease == 1 && (formModel.leaseTypeOfContract == 3 && false)"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.residentialQuestion"
          :label="locales.residentialQuestion"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          :validates="`required|isValid: ${locales.residentialQuestionValidation}, ${!(formModel.typeOfTheLease==2)}`"
          :disabled="isChecking || viewMode"
          @change="residentialCommercialQuestionReset"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.purposeOfTheLease == 2 && (formModel.leaseTypeOfContract == 3 && false)"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.commercialQuestion"
          :label="locales.commercialQuestion"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          :validates="`required|isValid: ${locales.residentialQuestionValidation}, ${!(formModel.typeOfTheLease==2)}`"
          :disabled="isChecking || viewMode"
          @change="residentialCommercialQuestionReset"
        ></naj-input>
      </v-col>

      <v-col
        v-if="formModel.commercialQuestion == 1 ||formModel.residentialQuestion == 1"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.durationQuestion"
          :label="locales.durationQuestion"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          validates="required"
          :disabled="isChecking || viewMode"
          @change="durationQuestionReset"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.durationQuestion == 2"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :value.sync="formModel.descriptionOfTheLease"
          :label="locales.descriptionOfTheLease"
          :items="descriptionOfLease"
          item-value="id"
          item-text="name"
          validates="required"
          :disabled="isChecking || viewMode"
          @change="descriptionOfTheLease"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.descriptionOfTheLease >= 10"
        cols="6"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.typeOfTheLease"
          :label="locales.typeOfTheLease"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          validates="required"
          :disabled="isChecking || viewMode"
        ></naj-input>
      </v-col>
      <v-col
        v-if="false"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.contractFee"
          :label="locales.contractFee"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          :validates="`required|isValid: ${locales.contractFeeValidation}, ${(formModel.contractFee==1)}`"
          :disabled="isChecking || viewMode"
          @change="$set(formModel, 'item', null);"
        ></naj-input>
      </v-col>

      <v-col
        v-if="formModel.leaseTypeOfContract == 1"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.item"
          :label="locales.item"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          validates="required"
          :disabled="isChecking || viewMode"
          @change="resetItem3"
        ></naj-input>
      </v-col>

      <v-col
        v-if="formModel.item == 2 "
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.item3"
          :label="locales.item3"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          :validates="`required|isValid: ${locales.item3Validation}, ${!(formModel.item3==2)}`"
          :disabled="isChecking || viewMode"
        ></naj-input>
      </v-col>

      <v-col
        v-if="formModel.purposeOfTheLease == 2 && formModel.contractFee == 1"
        cols="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.item"
          :label="locales.item2"
          :items="yesNoOption"
          item-value="id"
          item-text="name"
          :validates="`required|isValid: ${locales.itemValidation}, ${!(formModel.item==2)}`"
          :disabled="isChecking || viewMode"
          @change="resetItem3"
        ></naj-input>
      </v-col>
      <template v-if="showContractStatus">
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :label="locales.requestNumber"
            :value.sync="formModel.leaseRequestNumber"
            :validates="`${showContractStatus ? 'required' + (!isFormValidated?'|isVerified:'+formModel.leaseIsRetrieved:'') :''}`"
            :disabled="isChecking || viewMode || formModel.leaseIsRetrieved"
            :generated-id.sync="formModel.validators.leaseRequestNumber"
            @input="isFormValid = false ; isFormValidated = false"
          ></naj-input>
        </v-col>
        <v-col
          v-if="!formModel.leaseIsRetrieved"
          cols="3"
          align-self="center"
          class="text-right"
        >
          <naj-button
            square
            :loading="isChecking"
            :disabled="isCheckButtonDisabled"
            @click="check"
          >
            {{ local.personInformation.check }}
          </naj-button>
        </v-col>
        <v-col
          v-else
          cols="3"
        >
          <naj-error-text
            :text="realStateConfirmationText"
            size="medium"
            no-margin
          ></naj-error-text>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-col cols="4">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.firstPartyName"
                :value.sync="formModel.firstPartyName"
                disabled
              ></naj-input>
            </v-col>
            <v-col cols="4">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.partySocialIdType"
                :value.sync="formModel.firstPartySocialIdType"
                disabled
              ></naj-input>
            </v-col>
            <v-col cols="4">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.partySocialIdNumber"
                :value.sync="formModel.firstPartySocialId"
                disabled
              ></naj-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.secondPartyName"
                :value.sync="formModel.secondPartyName"
                disabled
              ></naj-input>
            </v-col>
            <v-col cols="4">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.partySocialIdType"
                :value.sync="formModel.secondPartySocialIdType"
                disabled
              ></naj-input>
            </v-col>
            <v-col cols="4">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.partySocialIdNumber"
                :value.sync="formModel.secondPartySocialId"
                disabled
              ></naj-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <naj-input
                :type-id="formFieldType.text"
                :label="locales.fullAddress"
                :value.sync="formModel.fullAddress"
                disabled
              ></naj-input>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </v-row>
    <v-row v-if="showContractCopy">
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.text"
          :label="locales.contractNumber"
          :value.sync="formModel.leaseContractNumber"
          :validates="`required|numeric${ !isFormValidated?'|isVerified:'+formModel.leaseIsRetrieved:''}`"
          :disabled="isChecking || viewMode || formModel.leaseIsRetrieved"
          :generated-id.sync="formModel.validators.leaseContractNumber"
          @input="isFormValid = false ; isFormValidated = false"
        ></naj-input>
      </v-col>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.partySocialId"
          :value.sync="formModel.leasePartySocialId"
          validates="required|long|max:10"
          :disabled="isChecking || viewMode || formModel.leaseIsRetrieved"
          :generated-id.sync="formModel.validators.leasePartySocialId"
          @input="isFormValid = false ; isFormValidated = false"
        ></naj-input>
      </v-col>
      <v-col cols="3">
        <naj-input
          :type-id="formFieldType.number"
          :label="locales.versionNumber"
          :value.sync="formModel.leaseVersionNumber"
          validates="required|numeric"
          :disabled="isChecking || viewMode || formModel.leaseIsRetrieved"
          :generated-id.sync="formModel.validators.leaseVersionNumber"
          @input="isFormValid = false ; isFormValidated = false"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!formModel.leaseIsRetrieved"
        cols="3"
        align-self="center"
        class="text-right"
      >
        <naj-button
          square
          :loading="isChecking"
          :disabled="isCheckButtonDisabled"
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
      </v-col>
      <v-col
        v-else
        cols="3"
      >
        <naj-error-text
          :text="realStateConfirmationText"
          size="medium"
          no-margin
        ></naj-error-text>
      </v-col>
    </v-row>
  </naj-box>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');

export default {
  inject: ['$validator'],
  name: 'EvacuationContractDetails',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isChecking: false,
      isFormValid: false,
      isFormValidated: false,
      realStateConfirmationText: null,
      promises: [],
    };
  },
  computed: {
    ...mapLUTState(['typeOfContract', 'yesNoOption']),
    purposeOfTheLease() {
      return [{
        id: 1,
        name: 'سكني',
      }, {
        id: 2,
        name: 'غير سكني',
      }];
    },
    descriptionOfLease() {
      return [{

        id: 1,
        name: 'استراحة',
      }, {
        id: 2,
        name: 'أرض بيضاء',
      }, {
        id: 3,
        name: 'مزرعة',
      }, {
        id: 4,
        name: 'شقق فندقية',
      }, {
        id: 5,
        name: 'أرض مملوكة للدولة',
      }, {
        id: 10,
        name: 'أخرى',
      }];
    },
    locales() {
      return this.local.dynamicFormAdmin.customComponents.ContractDetails;
    },
    showContractCopy() {
      return (this.formModel.leaseTypeOfContract === 1);
    },
    showContractStatus() {
      return (this.formModel.leaseTypeOfContract === 2);
    },
    isCheckButtonDisabled() {
      return (
        this.showContractCopy ? (
          !this.formModel.leaseContractNumber ||
          !this.formModel.leasePartySocialId ||
          !this.formModel.leaseVersionNumber ||
          this.isChecking) : this.showContractStatus ? (!this.formModel.leaseRequestNumber || this.isChecking) : true
      );
    },
  },
  created() {
    this.$set(this.formModel, 'validators', {});
  },
  methods: {
    ...mapSysActions(['verifyLeaseContract']),
    resetForm() {
      this.$set(this.formModel, 'leaseContractNumber', null);
      this.$set(this.formModel, 'leaseRequestNumber', null);
      this.$set(this.formModel, 'leasePartySocialId', null);
      this.$set(this.formModel, 'leaseVersionNumber', null);
      this.$set(this.formModel, 'leaseIsRetrieved', false);
      this.$set(this.formModel, 'purposeOfTheLease', null);
      this.$set(this.formModel, 'residentialQuestion', null);
      this.$set(this.formModel, 'commercialQuestion', null);
      this.$set(this.formModel, 'contractFee', null);
      this.$set(this.formModel, 'durationQuestion', null);
      this.$set(this.formModel, 'descriptionOfTheLease', null);
      this.$set(this.formModel, 'typeOfTheLease', null);
      this.$set(this.formModel, 'item', null);
      this.$set(this.formModel, 'firstPartyName', null);
      this.$set(this.formModel, 'firstPartySocialIdType', null);
      this.$set(this.formModel, 'firstPartySocialId', null);
      this.$set(this.formModel, 'secondPartyName', null);
      this.$set(this.formModel, 'secondPartySocialIdType', null);
      this.$set(this.formModel, 'secondPartySocialId', null);
      this.$set(this.formModel, 'fullAddress', null);
      this.$validator.reset(this.formModel.validators.leaseRequestNumber);
      this.isFormValid = false;
      this.isFormValidated = false;
      setTimeout(() => { this.validateLeaseTypeOfContract(); }, 0);
    },
    purposeOfTheLeaseReset() {
      this.$set(this.formModel, 'residentialQuestion', null);
      this.$set(this.formModel, 'commercialQuestion', null);
      this.$set(this.formModel, 'contractFee', null);
      this.$set(this.formModel, 'durationQuestion', null);
      this.$set(this.formModel, 'descriptionOfTheLease', null);
      this.$set(this.formModel, 'typeOfTheLease', null);
      this.$set(this.formModel, 'item', null);
      this.$set(this.formModel, 'item3', null);
    },
    residentialCommercialQuestionReset() {
      this.$set(this.formModel, 'contractFee', null);
      this.$set(this.formModel, 'durationQuestion', null);
      this.$set(this.formModel, 'descriptionOfTheLease', null);
      this.$set(this.formModel, 'typeOfTheLease', null);
      this.$set(this.formModel, 'item', null);
    },
    durationQuestionReset() {
      this.$set(this.formModel, 'descriptionOfTheLease', null);
      this.$set(this.formModel, 'typeOfTheLease', null);
    },
    descriptionOfTheLease() {
      this.$set(this.formModel, 'typeOfTheLease', null);
    },
    validateLeaseTypeOfContract() {
      this.$validator.validate(this.formModel.validators.leaseTypeOfContract);
    },
    validateLeaseContractCopy() {
      this.promises = [
        this.$validator.validate(this.formModel.validators.leaseContractNumber),
        this.$validator.validate(this.formModel.validators.leasePartySocialId),
        this.$validator.validate(this.formModel.validators.leaseVersionNumber)];
    },
    validateLeaseContractStatus() {
      this.promises = [];
    },
    check() {
      this.isFormValidated = true;
      this.$nextTick(() => {
        this.validateLeaseTypeOfContract();
        this.showContractCopy ? this.validateLeaseContractCopy() : this.validateLeaseContractStatus();
        Promise.all(this.promises)
          .then((validations) => {
            const valid = !validations.includes(false);
            if (valid || (!valid && this.isFormValid)) {
              this.isFormValid = true;
              this.isChecking = true;
              this.$set(this.formModel, 'leaseIsRetrieved', false);
              const payLoad = this.showContractCopy ? this.formModel : this.formModel.leaseRequestNumber;
              this.verifyLeaseContract(payLoad)
                .then((res) => {
                  const msg = res.succeeded ? this.local.dynamicFormAdmin.customComponents.ContractDetails.verificationSucceededUploadSucceeded :
                    this.local.dynamicFormAdmin.customComponents.ContractDetails.verificationSucceededUploadFailed;
                  this.toaster.success(msg);
                  this.realStateConfirmationText = msg;
                  const firstParty = res.firstParty || {};
                  const secondParty = res.secondParty || {};
                  this.$set(this.formModel, 'firstPartyName', firstParty.name);
                  this.$set(this.formModel, 'firstPartySocialIdType', firstParty.socialIdType);
                  this.$set(this.formModel, 'firstPartySocialId', firstParty.socialId);

                  this.$set(this.formModel, 'secondPartyName', secondParty.name);
                  this.$set(this.formModel, 'secondPartySocialIdType', secondParty.socialIdType);
                  this.$set(this.formModel, 'secondPartySocialId', secondParty.socialId);
                  this.$set(this.formModel, 'fullAddress', res.fullAddress);
                  this.$set(this.formModel, 'leaseIsRetrieved', true);
                })
                .catch((err) => {
                  this.toaster.error(err);
                  this.$set(this.formModel, 'leaseIsRetrieved', false);
                  this.isChecking = false;
                })
                .finally(() => {
                  this.isChecking = false;
                  this.isFormValidated = false;
                });
            }
          });
        this.isFormValidated = false;
      });
    },
    resetItem3() {
      this.$set(this.formModel, 'item3', null);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
